import React from 'react'

import {IntegrationType} from '../Integrations.consts'

import DockerIntegrationForm from './DockerIntegrationForm/DockerIntegrationForm'
import NpmIntegrationForm from './NpmIntegrationForm/NpmIntegrationForm'

type Props = {
  id?: string
  type: string
  parameters?: Record<string, string>
  onClose: () => void
}

function IntegrationSettingsForm({type, ...restProps}: Props) {
  return (
    <>
      {type === IntegrationType.NPM && <NpmIntegrationForm {...restProps} />}
      {type === IntegrationType.DOCKER && <DockerIntegrationForm {...restProps} />}
    </>
  )
}

export default IntegrationSettingsForm
